import { apiCall, ApiConfig } from '../../config/api'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { TypeOperation } from '../../interfaces/TypeOperation/TypeOperation'
import { GET_TYPE_OPERATION } from '../types/typeOperationActionstypes'
import { getTypeOperationAction } from '../actions/TypeOperationActions'

export function* getTypeOperationAsync() {
  try {
    const { status, data }: AxiosResponse<TypeOperation[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeOperationApi}`
    )
    if (status === 200) {
      yield put(getTypeOperationAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeOperationAction([], serverError.message))
  }
}

export function* watchGetTypeOperationAsync() {
  yield takeEvery(GET_TYPE_OPERATION, getTypeOperationAsync)
}
